import PropTypes from 'prop-types';
export var StepState;
(function (StepState) {
    StepState["ACTIVE"] = "active";
    StepState["DONE"] = "done";
    StepState["INACTIVE"] = "inactive";
})(StepState || (StepState = {}));
export const StepperPropTypes = {
    active: PropTypes.number,
    children: PropTypes.node.isRequired
};
export const StepPropTypes = {
    state: PropTypes.number,
    index: PropTypes.number
};
export const StepperDefaultValues = {};
export const StepDefaultValues = {};
//# sourceMappingURL=stepper.prop-types.js.map